<template>
  <div>
    <!-- mobile -->
    <div v-if="wW <= 1259" class="ismobile">
      <div class="bg"></div>
      <div class="headbox">
        <div class="header">
          <img src="@/assets/img/mobile/logo.png" alt="" class="logo">
          <div class="inputbox">
            <select v-model="searchSelected" @change="setMoblieSelect" name="" id="">
              <option :value="k" v-for="(v, k) in navList">{{ v }}</option>
            </select>
            <div class="line"></div>
            <input v-model="searchName" type="text" placeholder="搜索规则关键词、标题" class="inp">
            <div @click="search" class="btn">
              <img src="@/assets/img/icon-search.png" alt="" class="ico">
            </div>
          </div>
        </div>
      </div>
      <div v-if="list.length > 0" class="mainbox">
        <div class="leftmobilebox">
          <div class="swiper-container mySwiper">
            <div class="swiper-wrapper">
              <div @click="swiperClick(item, index)" v-for="(item, index) in list"
                :class="'swiper-slide ' + (selectedKey[0] == index ? 'cur' : '')">
                {{ item.name }}</div>
            </div>
          </div>
          <div v-if="list[selectedKey[0]] && list[selectedKey[0]].category && list[selectedKey[0]].category.length > 0"
            class="snavbox">
            <div @click="childClick(sitem, selectedKey[0] + '-' + sindex)"
              v-for="(sitem, sindex) in list[selectedKey[0]].category"
              :class="'item ' + (selectedKey[1] == sindex ? 'cur' : '')"> {{ sitem.name }}
            </div>
          </div>
        </div>

        <div class="rightbox">
          <router-view :nowTime="nowTime" :module="(navCur * 1 + 1) * 10" :nowCateItem="nowCateItem"
            :nowCateName="nowCateName" :menuList="list" :article_title="article_title"
            @result="childResult"></router-view>
        </div>
      </div>
      <div v-else-if="isAjax" class="nodata">暂无分类</div>
      <div class="footerbox">
        <div class="p">Copyright © 2025 casdt.cn 浙ICP备2024140619号-1 </div>
        <div class="p">中科国采(浙江自贸区)技术发展有限公司</div>
        <div class="p">All Rights Reserved 中科国采(浙江自贸区)技术发展有限公司版权所有 BY：中科国采</div>
      </div>
    </div>
    <!-- PC -->
    <div v-if="wW >= 1260" class="appbox ispc">
      <div class="headbox">
        <div class="header">
          <img src="@/assets/img/logo.svg" alt="" class="logo">
          <div class="blo1"></div>
          <div class="navbox">
            <router-link class="item" :to="{ 'name': 'home' }">招商中心</router-link>
            <div @click="setCur(k, 2)" v-for="(v, k) in navList" :class="'item ' + (navCur == k ? 'cur' : '')">{{ v }}
            </div>
          </div>
          <div class="blo2"></div>
          <div class="inputbox">
            <select v-model="searchSelected" @change="setSelect" name="" id="">
              <option :value="k" v-for="(v, k) in navList">{{ v }}</option>
            </select>
            <div class="line"></div>
            <input v-model="searchName" type="text" placeholder="搜索规则关键词、标题" class="inp">
            <div @click="search" class="btn">
              <img src="@/assets/img/icon-search.png" alt="" class="ico">
            </div>
          </div>
          <a :href="'/apply/#/?' + query" target="_blank" class="appbtn">商家入驻</a>
        </div>
        <div class="coverbg1"></div>
      </div>
      <div v-if="list.length > 0" class="mainbox">
        <div class="leftbox">
          <a-menu style="width: 154px" :selectedKeys="selectedKeys" :open-keys.sync="openKeys" mode="inline"
            @click="amenuClick">
            <template v-for="(item, index) in list">
              <a-sub-menu v-if="item.category && item.category.length > 0" :key="'sub' + index">
                <span slot="title">
                  <img v-if="item.image" :src="item.image.file_path" alt="" class="ico">
                  <span>{{ item.name }}</span>
                </span>
                <a-menu-item v-for="(sitem, sindex) in item.category" :key="index + '-' + sindex"
                  :class="item.image ? 'hasico' : 'nothasico'">
                  {{ sitem.name }}
                </a-menu-item>
              </a-sub-menu>

              <a-menu-item v-else :key="index + ''">
                <img v-if="item.image" :src="item.image.file_path" alt="" class="ico">
                <span>{{ item.name }}</span>
              </a-menu-item>
            </template>
          </a-menu>
        </div>

        <div class="rightbox">
          <div class="breadcrumb">
            <template>
              <a-breadcrumb v-if="nowCateName.length > 0">
                <a-breadcrumb-item v-for="(item, index) in nowCateName">{{ item }}</a-breadcrumb-item>
              </a-breadcrumb>
              <div v-else class="else">搜索结果</div>
            </template>
          </div>
          <router-view :nowTime="nowTime" :module="(navCur * 1 + 1) * 10" :nowCateItem="nowCateItem"
            :nowCateName="nowCateName" :menuList="list" :article_title="article_title"
            @result="childResult"></router-view>
        </div>
      </div>
      <div v-else-if="isAjax" class="nodata">暂无分类</div>
      <div class="footerbox">
        <div class="p">Copyright © 2025 casdt.cn 浙ICP备2024140619号-1 中科国采(浙江自贸区)技术发展有限公司</div>
        <div class="p">All Rights Reserved 中科国采(浙江自贸区)技术发展有限公司版权所有 BY：中科国采</div>
      </div>
    </div>


  </div>
</template>

<script>
import { supplierRuleCategory } from "@/server/api/index"
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
var mySwiper
export default {
  name: 'Index',
  components: {},

  data() {
    return {
      wW: document.body.clientWidth,
      resData: {},
      navList: ['规则中心', '帮助中心'],
      navCur: 0,//0规则中心 1帮助中心
      per_page: 10,
      page: 0,
      total: 0,

      nowCateItem: {},
      // nowcateKey: [],
      nowCateName: [],
      searchSelected: 0,
      searchName: '',
      article_title: '',

      selectedKeys: '',
      openKeys: '',
      list: [],
      nowTime: 0,
      isAjax: false,


      activeKey: '', selectedKey: [],
      query: '',
    };
  },
  watch: {

  },
  created() {
    this.query = localStorage.getItem('query')
    // //console.log('this.$router', this.$route)
    supplierRuleCategory().then(res => {
      this.resData = [res.data.rule_category ? [...res.data.rule_category] : [], res.data.help_category ? [...res.data.help_category] : []]
      // //console.log('this.resData', this.resData)
      this.setCur(0, 1)
      this.isAjax = true
    })
  },
  mounted() {
    setTimeout(() => {
      if (this.wW <= 1259) {
        //console.log('11111', this.selectedKey)
        mySwiper = new Swiper(".mySwiper", {
          slidesPerView: 5.4
        });
        if (this.selectedKey.length > 1) {
          //console.log('22222', this.selectedKey[0])
          if (this.selectedKey[0] >= 2 && this.selectedKey[0] <= this.list.length - 3) {
            mySwiper.slideTo(this.selectedKey[0] - 2, 500, false);//切换到
          } else if (this.selectedKey[0] > this.list.length - 3) {
            mySwiper.slideTo(this.list.length - 3, 500, false);//切换到
          }
        }
      }
    }, 600)

  },
  methods: {
    setMoblieSelect(e) {
      //console.log('eee', e, this.searchSelected)
      this.setCur(this.searchSelected, 2)
      setTimeout(() => {
        if (this.wW <= 1259) {
          mySwiper = new Swiper(".mySwiper", {
            slidesPerView: 5.4
          });
        }
      }, 100)
    },
    swiperClick(item, index) {
      this.selectedKey = [index]
      if (this.wW <= 1259) {
        if (index >= 0 && index <= this.list.length - 1) {
          mySwiper.slideTo(index - 2, 500, false);//切换到第一个slide，速度为1秒
        }
      }
      if (this.list[index] && this.list[index].category && this.list[index].category.length > 0) {
        this.childClick('', index + '-0')
      } else {
        this.childClick('', index)
      }
    },
    childClick(sitem, key) {
      //console.log('click',  key);
      let arr = (key + '').split('-')
      this.selectedKey = arr
      this.selectedKeys = [key]
      this.openKeys = ['sub' + arr[0]]
      this.activeKey = 'sub' + arr[0]
      // //console.log('arr2', arr)
      this.nowCateName = [
        this.list[arr[0]].name
      ]
      this.nowCateItem = this.list[arr[0]]
      if (arr[1] >= 0) {
        this.nowCateName.push(this.list[arr[0]].category[arr[1]].name)
        this.nowCateItem = this.list[arr[0]].category[arr[1]]
      }
      this.article_title = this.searchName = ''
      this.nowTime = new Date().getTime()
      this.$router.push({ name: 'list', query: { fkey: this.navCur, key: key } })
    },


    setSelect(e) {
      // //console.log('eee', e, this.searchSelected)
    },
    setCur(k, num) {
      this.navCur = k
      // //console.log('this.list', this.list)
      let arr = [0, 0], key = '0-0'
      if (num == 1 && this.$route.name == 'list') {
        if (this.$route.query.fkey) {
          this.navCur = this.$route.query.fkey
        }
        if (this.$route.query.key) {
          key = this.$route.query.key + ''
          arr = key.split('-')
        }
      }
      this.searchSelected = this.navCur
      this.list = this.resData[this.navCur]
      if (this.list.length <= 0) return
      //console.log('arr', arr,'key',key,this.list[arr[0]].category&&this.list[arr[0]].category.length>0)
      this.nowCateName = [
        this.list[arr[0]].name
      ]
      this.nowCateItem = this.list[arr[0]]
      if (arr[1] >= 0 && this.list[arr[0]].category && this.list[arr[0]].category.length > 0) {
        this.nowCateName.push(this.list[arr[0]].category[arr[1]].name)
        this.nowCateItem = this.list[arr[0]].category[arr[1]]
      }
      this.selectedKey = arr
      this.selectedKeys = [key]
      this.openKeys = ['sub' + arr[0]]
      this.activeKey = 'sub' + arr[0]
      this.nowTime = new Date().getTime()
      if (num == 2) {
        this.$router.push({ name: 'list', query: { fkey: this.navCur, key: key } })
      }
    },
    amenuClick(e) {
      //console.log('click', e, e.key);
      let arr = (e.key + '').split('-')
      this.selectedKeys = [e.key]
      this.openKeys = ['sub' + arr[0]]
      this.activeKey = 'sub' + arr[0]
      // //console.log('arr2', arr)
      this.nowCateName = [
        this.list[arr[0]].name
      ]
      this.nowCateItem = this.list[arr[0]]
      if (arr[1] >= 0) {
        this.nowCateName.push(this.list[arr[0]].category[arr[1]].name)
        this.nowCateItem = this.list[arr[0]].category[arr[1]]
      }
      this.article_title = this.searchName = ''
      this.nowTime = new Date().getTime()
      this.$router.push({ name: 'list', query: { fkey: this.navCur, key: e.key } })
    },
    titleClick(e) {
      ////console.log('titleClick', e);
    },
    childResult(type, category) {
      ////console.log('type,category', type, category)
      if (type == 'details') {
        let key = [], nowCateName = [], navCur = 0
        this.resData.findIndex((cate, index) => {
          let hasCatek = cate.findIndex((v, k) => {
            if (v.id == category.id) {
              navCur = index
              key = [k]
              nowCateName = [v.name]
              return true
            } else {
              let hasn = v.category.findIndex((m, n) => {
                navCur = index
                key = [k, n]
                nowCateName = [v.name, m.name]
                return m.id == category.id
              })
              return hasn >= 0
            }
          })
          return hasCatek >= 0
        })
        this.navCur = navCur
        this.searchSelected = this.navCur
        this.list = this.resData[this.navCur]
        if (this.list.length <= 0) return
        this.selectedKey = key
        this.selectedKeys = [key.join('-')]
        this.openKeys = ['sub' + key[0]]
        this.activeKey = 'sub' + key[0]
        // //console.log('this.openKeys', this.openKeys,'this.selectedKeys',this.selectedKeys)
        this.nowCateName = nowCateName
      }
    },
    search() {
      if (this.searchName) {
        this.navCur = this.searchSelected
        this.list = this.resData[this.navCur]
        if (this.list.length <= 0) return
        this.article_title = this.searchName
        this.nowCateName = []
        this.nowCateItem = {}
        this.selectedKey = []
        this.selectedKeys = []
        this.openKeys = []
        this.activeKey = ''
        this.nowTime = new Date().getTime()
        this.$router.push({ name: 'list', query: { fkey: this.navCur } })
      }
    },
  },
}
</script>

<style lang='less' scoped>
@import "./rule.less";
</style>
